import * as React from "react";
import { Modal, ModalSize, ModalBody, ModalFooter, Form, Checkbox, AlertMessage, AlertType, CustomButton, ButtonType, CustomSubmitButton, RadioButton, HiddenInput } from "soprasteria-ui-library";
import { useAuth } from "../../../../App";
import { OrthodonticLkgCfPatientApi } from "../../../../api/OrthodonticLkgCfPatientApi";
import { LKG, CF } from "../../../../utils/LkgCfPatientTypeConstants";
import { IRegisterOrthodonticLkgCfPatient } from "../../../../models/IOrthodonticLkgCfPatient";

interface IRegisterOrthodonticLkgCfPatientModal {
    patientId: number;
    isPatientRegisteredAtOtherCareProvider: boolean;
    onPatientRegistered: () => any;
}

export const RegisterOrthodonticLkgCfPatientModal: React.FunctionComponent<IRegisterOrthodonticLkgCfPatientModal> = ({ patientId, isPatientRegisteredAtOtherCareProvider, onPatientRegistered }) => {
    const auth = useAuth();
    const api = new OrthodonticLkgCfPatientApi(auth);
    const [errorMessage, setErrorMessage] = React.useState<string>("");
    const [isFormLoading, setIsFormLoading] = React.useState<boolean>(false);

    const onSubmit = (data: IRegisterOrthodonticLkgCfPatient) => {
        setIsFormLoading(true);
        api.registerLkgCfPatient(data, () => {
            document.getElementById("close-register-lkgcf-patient-modal")?.click();
            onPatientRegistered();
        }, (errorMessage: string) => {
            setIsFormLoading(false);
            setErrorMessage(errorMessage);
        });
    }

    const renderLkgCfPatientTypeChoice = () => {
        if (isPatientRegisteredAtOtherCareProvider) {
            return null;
        }
        return (
            <>
                <p><strong>Välj patienttyp nedan:</strong></p>
                <RadioButton name="orthodonticLkgCfPatientTypeId" label="LKG" value={LKG.toString()} inlineLabel required />
                <RadioButton name="orthodonticLkgCfPatientTypeId" label="CF" value={CF.toString()} inlineLabel required />
            </>
        );
    }

    const renderOvertakingRegistrationMessage = () => {
        if (isPatientRegisteredAtOtherCareProvider) {
            return (
            <>
                <p />
                <Checkbox value="agreement" label="Jag bekräftar att en överenskommelse med tidigare vårdgivare finns" name="agreement" id="agreement" required labelCol={9} inputCol={3} />
            </>);
        }
        return null;
            
    }

    return (
        <Modal header="Registrera patient" id="register-lkgcf-patient-modal" preventCloseOnOutsideClick={false} modalSize={ModalSize.normal}>
            <Form onSubmit={onSubmit}>
                <ModalBody>
                    <AlertMessage alertType={AlertType.danger} duration={3000} >{errorMessage}</AlertMessage>
                    <p>När registrering har skett kommer patienten ej kunna flyttas över till systemet för tandregleringscheck även om patienten avslutas i förtid.</p>

                    <HiddenInput name="patientId" value={patientId.toString()} />
                    {renderLkgCfPatientTypeChoice()}
                    {renderOvertakingRegistrationMessage()}
                </ModalBody>
                <ModalFooter>
                    <div className="text-right btn-group" role="group">
                        <CustomButton buttonType={ButtonType.general} data-dismiss="modal" buttonText="Avbryt" id="close-register-lkgcf-patient-modal" />
                        <CustomSubmitButton isLoading={isFormLoading}>Registrera patienten</CustomSubmitButton>
                    </div>
                </ModalFooter>
            </Form>
        </Modal>
    )
}